import { httpsCallable } from 'firebase/functions';
import { databaseId, functions } from '@/lib/firebase';

export interface Report {
  reporterUid: string;
  reportedUid: string;
  details: string;
  createdAt: string;
}

export interface SubmitReportInput {
  reportedUid: string;
  details: string;
}

const submitReportFn = httpsCallable<{ databaseId: string } & SubmitReportInput, { success: true }>(
  functions,
  'submitReport'
);

export const reportService = {
  async submitReport(input: SubmitReportInput): Promise<void> {
    await submitReportFn({ databaseId, ...input });
  },
};
